import { useState } from "react";

import clsx from "clsx";

import { ModalPanel, ModalPanelContent } from "@components/v2/modal-panel";
import {
  WizardProgress,
  WizardProvider,
  WizardStepper,
} from "@components/v2/wizard";
import { DestinationForm } from "@features/data-export-v2/destination/destination-form";
import { ScheduleExportFormProvider } from "@features/data-export-v2/hooks/useScheduleExportFormContext";
import { ReportDataForm } from "@features/data-export-v2/report-data/report-data-form";
import { ScheduleForm } from "@features/data-export-v2/trigger/schedule-trigger-form";

import { ScheduleExportFooter } from "./schedule-export-footer";

const EXPORTS_WIZARD_STEPS = [
  {
    id: "report_type",
    label: "Report Type",
    iconName: "fa-file-chart-column",
  },
  {
    id: "destination",
    label: "Destination",
    iconName: "fa-file-export",
  },
  {
    id: "schedule",
    label: "Schedule",
    iconName: "fa-calendar",
  },
] as const;

export type ExportWizardStepId = (typeof EXPORTS_WIZARD_STEPS)[number]["id"];
export type ScheduleExportFormProps = {
  onClose?(): void;
};

export const ScheduledExportForm = ({ onClose }: ScheduleExportFormProps) => {
  const [activeStepId, setActiveStepId] =
    useState<ExportWizardStepId>("report_type");

  const steps = EXPORTS_WIZARD_STEPS.map((step) => ({
    value: step.id,
    label: step.label,
    icon: <i className={clsx("fa-regular", step.iconName)}></i>,
  }));

  return (
    <ScheduleExportFormProvider>
      <div className="grid grid-cols-[312px_auto] gap-1.5 overflow-hidden h-full">
        <WizardProvider
          onChange={(step) => setActiveStepId(step)}
          active={activeStepId}
          steps={steps}
        >
          <ModalPanel className="overflow-hidden p-0">
            <ModalPanelContent
              footer={<WizardProgress className="rounded-b" />}
            >
              <WizardStepper />
            </ModalPanelContent>
          </ModalPanel>
          <ModalPanel className="overflow-hidden p-0">
            <ModalPanelContent
              footer={
                <ScheduleExportFooter onCancel={onClose} onFinish={onClose} />
              }
            >
              {activeStepId === "report_type" && <ReportDataForm />}
              {activeStepId === "destination" && <DestinationForm />}
              {activeStepId === "schedule" && <ScheduleForm />}
            </ModalPanelContent>
          </ModalPanel>
        </WizardProvider>
      </div>
    </ScheduleExportFormProvider>
  );
};
